import { useBannerStore } from '@/store/useBannerStore/useBannerStore';
import { BannerSource } from '@/store/useBannerStore/useBannerStore.types';

export function useIsTopBannerVisible() {
  const { isAdriverTopBannerVisible, isAdManagerTopBannerVisible } =
    useBannerStore(state => ({
      isAdriverTopBannerVisible: state.isAdriverTopBannerVisible,
      isAdManagerTopBannerVisible:
        state.bannerTopSource === BannerSource.Admanager,
    }));

  return isAdriverTopBannerVisible || isAdManagerTopBannerVisible;
}
